module.exports = __webpack_public_path__ + "img/Single-dependant.970ec926.svg";